export default {"src":"/_next/static/media/cashTrust.818effa9.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};